import { createContext } from 'react';

const LocaleContext = createContext({
  locale: 'default-locale',
  setLocale: () => {}
});

export default LocaleContext;